"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerRemittanceSummary = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.CustomerRemittanceSummary = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    transaction_id: typebox_1.Type.String(),
    remittance_total: typebox_1.Type.String(),
    payment_method: typebox_1.Type.String(),
});
//# sourceMappingURL=customer-remittance-summary.js.map